import type { TourDefinition, TourKey } from '../types/tour';
import { realtimeFirstVisitTour } from './definitions/realtimeFirstVisit';
import { workspaceSwitchFirstTour } from './definitions/workspaceSwitchFirst';
import { widgetCustomizationFirstTour } from './definitions/widgetCustomizationFirst';
import { workspacesSettingsFirstTour } from './definitions/workspacesSettingsFirst';
import { sessionDetailFirstTour } from './definitions/sessionDetailFirst';

export const TourRegistry: Record<TourKey, TourDefinition> = {
  realtime_first_visit: realtimeFirstVisitTour,
  workspace_switch_first: workspaceSwitchFirstTour,
  widget_customization_first: widgetCustomizationFirstTour,
  workspaces_settings_first: workspacesSettingsFirstTour,
  session_detail_first: sessionDetailFirstTour,
};

export function getTourDefinition(key: string): TourDefinition | null {
  return (TourRegistry as Record<string, TourDefinition | undefined>)[key] ?? null;
}
